import { useGetImagesProductMutation } from '@/shared/api-rtk/index.js'
import { useEffect, useState } from 'react'
import CarouselImages from '@/shared/ui/CarouselImages/index.js'
import CarouselCatalogItem from '@/shared/ui/CarouselCatalogItem/index.js'
import { AddToPreferences } from '@/features/productSearch/ProductCardActions'

import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const GalleryImages = ({ product }) => {
    const image = product.image
    const productId = product.product_id

    const [imagesGallery, setImagesGallery] = useState([{ image }])
    const [getImages] = useGetImagesProductMutation()

    useEffect(() => {
        getImages(productId)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setImagesGallery((prev) => [
                        ...prev,
                        ...Object.values(res.data),
                    ])
                }
            })
    }, [productId])

    return (
        <div className={'GalleryImages'}>
            <AddToPreferences item={product} productId={productId} />
            <CarouselCatalogItem imagesProduct={imagesGallery} />
        </div>
    )
}
